import React from "react";
import styles from "./index.module.css";
import { userContext } from "../../Context/user";
import { db, fbFunctions, storage } from "../../fire";
import { InvoiceFileInput } from "../../InvoiceFileInput";
import { Pie } from "@nivo/pie";
import { PieChart } from "../../Components/PieChart";
import { MDBIcon } from "mdbreact";

export class Production extends React.Component {
  state = {
    totalHomologated: 0,
    totalNotBilled: 0,
    totalAverage: 0,
    totalGains: 0,
    toBeBilled: 0,
    monthHomologated: 0,
    monthNotBilled: 0,
    showInvoce: false,
    generatingInvoice: false,
    documents: [],
    isDetailsVisible: false,
    producedPiles: [],
    loadingInitialData: true
  };

  async componentDidMount() {
    try {
      await this.checkIfInvoiceAlreadyExist();
      await this.getData();
    } catch {
    } finally {
      this.setState({ loadingInitialData: false });
    }
  }

  checkIfInvoiceAlreadyExist = async () => {
    try {
      const { user } = this.context;

      const invoicesRef = await db
        .collection("faturas")
        .where("pago", "==", false)
        .where("prestadorID", "==", user.id)
        .get();

      if (invoicesRef.empty) return;

      const invoiceData = invoicesRef.docs.map(doc => {
        const docData = {
          docID: doc.id,
          ...doc.data()
        };

        return docData;
      })[0];

      this.setState({
        invoice: invoiceData,
        alreadyGeneratedInvoice: true,
        isDetailsVisible: true
      });
    } catch (error) {
      console.log({ error });
    }
  };

  getData = async () => {
    try {
      const { user } = this.context;
      const servicesRef = db.collection("pedidosDeServico");
      const statusCodes = ["Aprovado", "Faturado", "Pago"];

      const totalHomologatedRef = await servicesRef
        .where("prestadorID", "==", user.id)
        .where("status", "in", statusCodes)
        .get();

      const documents = totalHomologatedRef.docs.map(doc => {
        const data = doc.data();

        return {
          ...data,
          objetoResultadoRefID: data?.objetoResultadoRef?.id
        };
      });

      const totalHomologated = documents.length;

      const totalNotBilled = documents.filter(doc => doc.status === "Aprovado")
        .length;

      let totalAverage = documents.reduce(
        (acc, doc) => (acc + doc.avaliacao ? doc.avaliacao : 0),
        0
      );

      if (totalAverage > 0 && totalHomologated > 0) {
        totalAverage = totalAverage / totalHomologated;
      }

      const toBeBilled = documents
        .filter(doc => doc.status === "Aprovado")
        .reduce((acc, doc) => (acc + doc.valor ? doc.valor : 0), 0);

      const totalGains = documents
        .filter(doc => doc.status === "Pago")
        .reduce((acc, doc) => (acc + doc.valor ? doc.valor : 0), 0);

      const rawDate = new Date();
      const year = rawDate.getFullYear();
      const month = rawDate.getMonth();
      const date = new Date(year, month);

      const monthsDocs = documents.filter(doc => {
        if (!doc.horarioAprovacao) return false;
        return (
          statusCodes.includes(doc.status) &&
          doc.horarioAprovacao.toDate() > date
        );
      });

      const monthHomologated = monthsDocs.filter(doc => {
        if (!doc.horarioAprovacao) return false;
        return (
          doc.status === "Aprovado" && doc.horarioAprovacao.toDate() > date
        );
      }).length;

      const monthNotBilled = monthsDocs.filter(doc => doc.status === "Aprovado")
        .length;

      const producedPiles = documents.filter(
        doc => doc.horarioConclusao && doc.status !== "Pago"
      );

      const data = {
        totalHomologated,
        totalNotBilled,
        totalAverage,
        totalGains,
        toBeBilled,
        monthHomologated,
        monthNotBilled,
        documents,
        producedPiles
      };

      this.setState(data);

      console.log(data);
    } catch (error) {
      console.log({ error });
    }
  };

  generateInvoice = async () => {
    try {
      const { user } = this.context;
      this.setState({ generatingInvoice: true });
      const { data: invoice } = await fbFunctions.httpsCallable("geraFatura")();

      const invoicesRef = await db
        .collection("faturas")
        .where("numero", "==", invoice.numero)
        .limit(1)
        .get();

      const invoiceRef = invoicesRef.docs.map(doc => {
        const docData = {
          docID: doc.id,
          ...doc.data()
        };

        console.log({ docData });

        return docData;
      })[0];

      invoiceRef.prestadorID = user.id;
      invoiceRef.pago = false;

      await db
        .collection("faturas")
        .doc(invoiceRef.docID)
        .update(invoiceRef);

      this.setState({ invoice });
    } catch (error) {
      console.log({ error });
    } finally {
      this.setState({ generatingInvoice: false });
    }
  };

  toggleDetailsTable = () => {
    const { isDetailsVisible } = this.state;

    this.setState({ isDetailsVisible: !isDetailsVisible });
  };

  submitFile = async file => {
    try {
      const { invoice } = this.state;
      const { user } = this.context;

      this.setState({ submitingFile: true });

      if (!file) return;

      const storageRef = storage.ref();

      const fileRef = storageRef.child(`/notas-fiscais/${Date.now()}`);

      await fileRef.put(file);

      const fileUrl = await fileRef.getDownloadURL();

      const invoicesRef = await db
        .collection("faturas")
        .where("numero", "==", invoice.numero)
        .limit(1)
        .get();

      const invoiceRef = invoicesRef.docs.map(doc => {
        const docData = {
          docID: doc.id,
          ...doc.data()
        };

        console.log({ docData });

        return docData;
      })[0];

      invoiceRef.notaFiscalRef = fileUrl;
      invoiceRef.prestadorID = user.id;
      invoiceRef.pago = false;

      await db
        .collection("faturas")
        .doc(invoiceRef.docID)
        .update(invoiceRef);

      this.setState({
        file,
        invoice: invoiceRef,
        loadingInitialData: true
      });
      await this.checkIfInvoiceAlreadyExist();
    } catch (error) {
      console.log({ error });
    } finally {
      this.setState({ submitingFile: false, loadingInitialData: false });
    }
  };

  renderProductionTable() {
    const {
      totalHomologated,
      totalNotBilled,
      totalAverage,
      monthHomologated,
      monthNotBilled,
      totalGains,
      toBeBilled,
      generatingInvoice,
      isDetailsVisible
    } = this.state;

    if (isDetailsVisible) return;

    return (
      <div className={styles["production-container"]}>
        <h1 className="with-decoration">Faturamento e nota fiscal</h1>
        <div className="d-flex">
          <table className={styles["table-1"]}>
            <thead>
              <tr>
                <th>Período</th>
                <th className={styles["th-blue"]}>Blocos Homologados</th>
                <th className={styles["th-blue"]}>Blocos Não faturados</th>
                <th className={styles["th-blue"]}>%</th>
                <th className={styles["th-orange"]}>Avaliação média</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Produção</td>
                <td>{totalHomologated}</td>
                <td>{totalNotBilled}</td>
                <td>
                  {totalNotBilled > 0 && totalHomologated > 0
                    ? (totalNotBilled / totalHomologated).toFixed(2)
                    : 0}
                  %
                </td>
                <td>{totalAverage} %</td>
              </tr>
              <tr>
                <td>No mês</td>
                <td>{monthHomologated}</td>
                <td>{monthNotBilled}</td>
                <td>
                  {monthNotBilled > 0 && monthHomologated > 0
                    ? (monthNotBilled / monthHomologated).toFixed(2)
                    : 0}
                  %
                </td>
                <td>85%</td>
              </tr>
            </tbody>
          </table>
          <div className={styles["total-container"]}>
            <table>
              <thead>
                <tr>
                  <th>Já recebido</th>
                  <th>A faturar</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>R$ {totalGains}</td>
                  <td>R$ {toBeBilled}</td>
                </tr>
              </tbody>
            </table>
            <button
              disabled={generatingInvoice}
              onClick={this.toggleDetailsTable}
            >
              Faturar
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderPagVariavel() {
    const { isDetailsVisible } = this.state;

    if (isDetailsVisible) return;

    return (
      <div className={styles["production-container"]}>
        <h1 className="with-decoration">Pag. Variável</h1>
        <div className="d-flex">
          <table className={styles["table-1"]}>
            <thead>
              <tr>
                <th>Período</th>
                <th className={styles["th-blue"]}>Blocos Vendidos</th>
                <th className={styles["th-blue"]}>
                  % da Receita Oper. de Vendas Não faturados
                </th>
                <th className={styles["th-orange"]}>Avaliação média</th>
                <th className={styles["th-green"]}>Ganhos variáveis</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>No total</td>
                <td>9000</td>
                <td>5%</td>
                <td>85%</td>
                <td>R$ 2.550</td>
              </tr>
              <tr>
                <td>No mês</td>
                <td>9000</td>
                <td>6%</td>
                <td>90% %</td>
                <td>R$ 324</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderComentarios() {
    const { isDetailsVisible } = this.state;

    if (isDetailsVisible) return;

    return (
      <div className={styles["production-container"]}>
        <h1 className="with-decoration">Comentários em questões</h1>
        <div className="d-flex">
          <table className={`${styles["table-1"]} ${styles["table-2"]}`}>
            <thead>
              <tr>
                <th>Período</th>
                <th className={styles["th-blue"]}>Questões comentadas</th>

                <th className={styles["th-orange"]}>Avaliação média</th>
                <th className={styles["th-green"]}>Ganhos</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>No total</td>
                <td>1650</td>
                <td>85%</td>
                <td>2.085</td>
              </tr>
              <tr>
                <td>No total</td>
                <td>1650</td>
                <td>85%</td>
                <td>2.085</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderVideos() {
    const { isDetailsVisible } = this.state;

    if (isDetailsVisible) return;

    return (
      <div className={styles["production-container"]}>
        <h1 className="with-decoration">Vídeos gravados</h1>
        <div className="d-flex">
          <table className={`${styles["table-1"]} ${styles["table-2"]}`}>
            <thead>
              <tr>
                <th>Período</th>
                <th className={styles["th-blue"]}>Vídeos gravados</th>
                <th className={styles["th-orange"]}>Avaliação média</th>
                <th className={styles["th-green"]}>Ganhos</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>No total</td>
                <td>120</td>
                <td>85%</td>
                <td>1.085</td>
              </tr>
              <tr>
                <td>No total</td>
                <td>1650</td>
                <td>85%</td>
                <td>2.085</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderProvas() {
    const { isDetailsVisible } = this.state;

    if (isDetailsVisible) return;

    return (
      <div className={styles["production-container"]}>
        <h1 className="with-decoration">Provas dissertativas/redações</h1>
        <div className="d-flex">
          <table className={`${styles["table-1"]} ${styles["table-2"]}`}>
            <thead>
              <tr>
                <th>Período</th>
                <th className={styles["th-blue"]}>Provas corrigidas</th>
                <th className={styles["th-orange"]}>Avaliação média</th>
                <th className={styles["th-green"]}>Ganhos</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>No total</td>
                <td>1650</td>
                <td>85%</td>
                <td>2.085</td>
              </tr>
              <tr>
                <td>No total</td>
                <td>1650</td>
                <td>85%</td>
                <td>2.085</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderInvoice = () => {
    const {
      isDetailsVisible,
      producedPiles,
      invoice,
      generatingInvoice,
      file,
      alreadyGeneratedInvoice
    } = this.state;

    console.log({ producedPiles });

    if (!isDetailsVisible) return;

    return (
      <div className={styles["main-container"]}>
        {
          <div className={styles["table-container"]}>
            <table>
              <thead>
                <tr>
                  <th>Pilhas Produzidas</th>
                  <th>Não homologado</th>
                  <th>Homologado</th>
                  <th>Faturado</th>
                </tr>
              </thead>
              <tbody>
                {producedPiles.map(pile => {
                  return (
                    <tr key={pile.objetoResultadoRefID}>
                      <td>{pile.objetoResultadoRefID}</td>
                      <td>
                        {!["Aprovado", "Faturado"].includes(pile.status) && "X"}
                      </td>
                      <td
                        className={pile.status === "Aprovado" && styles.marked}
                      >
                        {pile.status === "Aprovado" && "X"}
                      </td>
                      <td>{pile.status === "Faturado" && "X"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <button
              disabled={generatingInvoice || alreadyGeneratedInvoice}
              onClick={this.generateInvoice}
            >
              {generatingInvoice
                ? "Por favor aguarde"
                : "Confirmar Faturamento"}
            </button>
          </div>
        }{" "}
        {invoice && (
          <div className={styles["invoice-container"]}>
            <header className={styles["invoice-header"]}>
              <h2>Fatura</h2> <p>n° {invoice.numero}</p>
            </header>
            <div className={styles["invoice-body"]}>
              <p className="text-center">{invoice.empresa.nome}</p>
              <p className="text-center">CNPJ: {invoice.empresa.cnpj}</p>
              <p>
                Endereço: {invoice.empresa.rua}, {invoice.empresa.numero},{" "}
                {invoice.empresa.complemento}
              </p>
              <div className={styles["adress-box"]}>
                <p>CEP: {invoice.empresa.cep}</p>
                <p>
                  {invoice.empresa.bairro} - {invoice.empresa.cidade} -{" "}
                  {invoice.empresa.estado}
                </p>
                <p>Telefone {invoice.empresa.telefone}</p>
                <p>
                  <a href={`mailto:${invoice.empresa.email}`}>
                    {invoice.empresa.email}
                  </a>
                </p>
              </div>
              <p>Natureza do serviço: {invoice.tipoServico}</p>
              <p className="text-center">Descrição do serviço</p>
              <p>{invoice.descricaoServico}</p>
              <footer className={styles["invoice-footer"]}>
                <p>Valor:</p>
                <p>R$</p>
                <p>{invoice.valor}</p>
              </footer>
            </div>
            <div className="d-flex justify-content-between align-items-center pt-3">
              <InvoiceFileInput
                alreadyDidUpload={file || invoice.notaFiscalRef}
                disabled={invoice.notaFiscalRef}
                onChange={this.submitFile}
              />
              {file || invoice.notaFiscalRef ? (
                <div>
                  Status:{" "}
                  <span
                    className={`${styles["invoice-status"]} ${
                      invoice.pago === "Pago"
                        ? styles["status-paid"]
                        : styles["status-not-paid"]
                    }`}
                  >
                    {invoice.pago ? "Pago" : "Ainda não pago"}
                  </span>
                </div>
              ) : null}
            </div>
          </div>
        )}
      </div>
    );
  };

  render() {
    const { loadingInitialData } = this.state;

    if (loadingInitialData) return null;

    return (
      <div className={styles.container}>
        <header className={styles.header}>
          <div
            className={`${styles.box} ${styles["box-blue"]}`}
            colormode="blue"
          >
            <p>P</p> <p>produtividade</p>
          </div>
          <div className={`${styles.box} ${styles["box-orange"]}`}>
            <p>A</p> <p>avaliação</p>
          </div>
          <div className={`${styles.box} ${styles["box-green"]}`}>
            <p>G</p> <p>ganhos</p>
          </div>
        </header>
        <div className="row">
          <div className="col-md-8">
            {this.renderProductionTable()}
            <div className="mt-4">{this.renderPagVariavel()}</div>
            <div className="mt-4">
              <div className={styles["production-container"]}>
                <p className="with-decoration">
                  PERGUNTAS E DÚVIDAS PARA RESPONDER
                </p>
                <table className={styles["table-questions"]}>
                  <thead>
                    <tr>
                      <th>Data</th>
                      <th>Aluno</th>
                      <th>Matéria</th>
                      <th>Bloco</th>
                      <th>Dúvida/Pergunta</th>
                      <th>Responder</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>11/12/19</td>
                      <td>Ana G.</td>
                      <td>DA01</td>
                      <td>da01b08</td>
                      <td>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Fugiat placeat architecto sint, vitae praesentium
                        doloremque
                      </td>
                      <td>
                        <MDBIcon
                          icon="comments"
                          size="2x"
                          className="green-text"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className={styles["production-container"]}>
              <p className="with-decoration">ESTATÍSTICAS DE GANHOS</p>
              <PieChart />
            </div>
            <div className="mt-4">{this.renderComentarios()}</div>
            <div className="mt-4">{this.renderVideos()}</div>
            <div className="mt-4">{this.renderProvas()}</div>
          </div>
        </div>
        {this.renderInvoice()}
      </div>
    );
  }
}

Production.contextType = userContext;
